<template>
  <div>
    <v-form ref="form"
            v-model="isFormValid"
            lazy-validation>
      <v-row>
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="clonedSelectedPartner.displayName"
                        outlined
                        dense
                        required
                        :label="translations.partnerName"
                        :rules="displayNameRules">
          </v-text-field>
        </v-col>
        <v-col v-if="isPartnerCreate"
               cols="12"
               sm="6">
          <v-text-field v-model="clonedSelectedPartner.integrationUri"
                        outlined
                        dense
                        required
                        :label="translations.integrationEndpointUriLabel"
                        :rules="integrationUriRules">
          </v-text-field>
        </v-col>
      </v-row>
      <transition name="slide"
                  appear>
        <v-card class="fotterCard"
                tile
                elevation="10"
                v-if="detailsModalToggler">
          <v-row class="px-8 py-3">
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn text
                     small
                     class="text-none"
                     width="120"
                     @click="cancelButton()">
                <LocalizedLabel>cancel</LocalizedLabel>
              </v-btn>
              <v-btn small
                     color="primary"
                     class="background--text text-none"
                     width="120"
                     :key="actionKey"
                     :disabled="disabledAction"
                     @click.once="actionButton()">
                <LocalizedLabel>save</LocalizedLabel>
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </transition>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import {
  isEntered,
  isUri,
  nameLength,
} from '@/utility';

export default {
  data() {
    return {
      actionKey: 0,
      isFormValid: true,
      disabledAction: false,
      clonedSelectedPartner: {},
    };
  },
  methods: {
    ...mapActions([
      'createData',
      'toggleDetailsModal',
      'getBootstrap',
      'updateData',
    ]),
    async createPartner() {
      const response = await this.createData({
        data: {
          displayName: this.clonedSelectedPartner.displayName,
          integrationUri: this.clonedSelectedPartner.integrationUri,
          active: true,
        },
        path: 'partners',
        notification: 'createPartnerLabel',
      });
      if (response) {
        this.reloadBootstrap();
      } else {
        this.actionKey += 1;
      }
    },
    async updatePartner() {
      const response = await this.updateData({
        data: { displayName: this.clonedSelectedPartner.displayName },
        path: `partners/${this.clonedSelectedPartner.id}`,
        notification: 'updatePartnerLabel',
      });
      if (response) {
        this.reloadBootstrap();
      } else {
        this.actionKey += 1;
      }
    },
    actionButton() {
      if (this.$refs.form.validate()) {
        this[this.detailsModalConfig.action]();
      } else {
        this.actionKey += 1;
      }
    },
    cancelButton() {
      this.toggleDetailsModal(false);
      this.$refs.form.reset();
    },
    async reloadBootstrap() {
      await this.toggleDetailsModal(false);
      this.getBootstrap();
    },
  },
  computed: {
    ...mapGetters([
      'detailsModalConfig',
      'selectedPartner',
      'translations',
      'detailsModalToggler',
    ]),
    isPartnerCreate() {
      return this.detailsModalConfig.createPartner;
    },
    isPartnerEdit() {
      return this.detailsModalConfig.updatePartner;
    },
    displayNameRules() {
      return [
        isEntered(this.clonedSelectedPartner.displayName,
          this.translations.partnerNameErrorLabel),
        nameLength(this.clonedSelectedPartner.displayName,
          this.translations.nameLengthErrorLabel),
      ];
    },
    integrationUriRules() {
      return [
        isEntered(this.clonedSelectedPartner.integrationUri,
          this.translations.requiredErrorLabel),
        isUri(this.translations.integrationUriErrorLabel),
      ];
    },
  },
  created() {
    if (this.isPartnerEdit) {
      this.clonedSelectedPartner = cloneDeep(this.selectedPartner);
    }
  },
};
</script>

<style>

</style>
